// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"_3OG2hI0arRNE","notes":"cHxIw_yvYFMh","control":"_1TWeLkdAvnpA","agree":"_1sAQZn4HY3nE","checkbox":"_3rLSm9gZZRMu","active":"_2sIxI23UJTv3"};